import { listenerManager } from '../../modules/services/ordersListenerManager';

// Global reset action: handled directly by the root reducer, which returns
// the pristine initial state for every slice.
export const AUTH_LOGOUT = 'auth/logout';

/**
 * Full store cleanup on logout. Stops every active Firestore listener first
 * (both those tracked by `listenerManager` and those whose unsubscribe fn
 * lives in the `{ list, unsubscribe }` stream slices), then dispatches the
 * global reset so no data from the previous user survives in Redux.
 */
export const resetStoreOnLogout = () => (dispatch, getState) => {
  listenerManager.stopAllListeners();

  const state = getState();
  Object.values(state).forEach((slice) => {
    if (typeof slice?.unsubscribe === 'function') {
      try {
        slice.unsubscribe();
      } catch (err) {
        console.error('Error unsubscribing Firestore listener on logout:', err);
      }
    }
  });

  dispatch({ type: AUTH_LOGOUT });
};
